import items from '@/data/dashboard/management-items'

export default {
  name: 'ManagementSection',
  data () {
    return {
      items
    }
  },
  methods: {
    icon (i) {
      return require('@/assets/images/icons/management/small/' + i.icon + '.png')
    }
  }
}